import ninegrid from "../index.js";
//import { ngData } from "./ngData.js";

export class ngView
{
	#owner;
	#rawIndex;
	#height;
	#ing;
	#timers = [];
	
	constructor(owner) {
		this.#owner = owner;
		
		this.#ing = false;
		
		this.init();
	}
	
	/**
	 * changelayout
	 * resize
	 */
	init = () => {
		
		//if (this.#ing) return;
		
		this.#height = {
			body : $(".ng-container-body", this.#owner.body).height() || 0,
			thead : $(".ng-container-body thead", this.#owner.body).height() || 0,
			tfoot : $(".ng-container-body tfoot", this.#owner.body).height() || 0,
		}
		
		if (this.#ing) return;
		
		$(".ng-container tbody.bindable tr.nodata", this.#owner.body).height(this.#height.body);
		
		this.#ing = true;
	};

	redraw = () => {

		this.#owner.touchEvent.scrollTop();
		
		this.init();
		
		if (!this.#owner.dataManager) return;

		this.#rawIndex = this.#owner.dataManager.viewRecords.rawIndex || 0;

		this.#resetTR3();
		
		this.#r();

		this.#owner.body.querySelector("ng-vscrollbar").refresh();
	};
	
	redrawV2 = () => {

		this.#owner.touchEvent.scrollTop();
		
		this.init();
		
		this.#rawIndex = this.#owner.dataManager.viewRecords.rawIndex || 0;
		
		this.#resetTR3V2();

		this.#r();
		this.#owner.body.querySelector("ng-vscrollbar").refreshV2();
	};
	
	redrawV3 = () => {

		this.init();
		
		this.#rawIndex = this.#owner.dataManager.viewRecords.rawIndex || 0;
		
		//this.#resetTR3V2();
	
		this.#r();
		//this.#owner.body.querySelector("ng-vscrollbar").refreshV2();
	};

	
	#getPinHeight = () => {
		var h = 0;
		
		$(".ng-container-body tbody.fixed tr", this.#owner.body).each((i, tr) => {
			if (tr.data && tr.data.__ng) {
				h += this.#owner.matrix.getHeight(tr.data.__ng.height[parseInt(i % this.#owner.template.length)]);
			}
		});
		
		return h;
	}
	
	#getTrHeight = () => {
		var h = this.#getPinHeight();
		
		const startRow = parseInt(this.#rawIndex * this.#owner.template.length);

		$(".ng-container-body tbody.bindable tr:not(.nodata)", this.#owner.body).each((i, tr) => {
			h += this.#owner.matrix.getHeight(startRow + i);
		});
		
		return h;
	}
	
	#getRowCount = () => {

		/**
		if (this.#height.body == 0 && this.#height.thead == 0 && this.#height.tfoot == 0) {
			this.#height = {
				body : $(".ng-container-body", this.#owner.body).height() || 0,
				thead : $(".ng-container-body thead", this.#owner.body).height() || 0,
				tfoot : $(".ng-container-body tfoot", this.#owner.body).height() || 0,
			}
		}

		console.log(this.#owner);
		console.log($(".ng-container-body", this.#owner.body));
			*/


		const displayRowCount = parseInt(this.#owner.getAttribute("display-row-count"));
//console.log("=======displayRowCount: ", displayRowCount, this.#owner.data.count());
		if (this.#owner.closest("dialog") && ninegrid.j.querySelectorAll(this.#owner).hasClass("simple")) return 1;
		if ([ninegrid.PAGINGTYPE.CLIENT,ninegrid.PAGINGTYPE.SERVER].includes(this.#owner.paging.type)) return this.#owner.paging.linesPerPage;
		if (!isNaN(displayRowCount)) {

			/**
			 * 데이타가 적을 경우 rawIndex = 0;
			 * 마지막 페이지 인경우 rawIndex 계산
			 */
			if (this.#rawIndex + displayRowCount > this.#owner.data.count()) {
				this.#rawIndex = (displayRowCount >= this.#owner.data.count()) ? 0 : this.#owner.data.count() - displayRowCount;
				this.#owner.dataManager.viewRecords.rawIndex = this.#rawIndex;
			}

			return displayRowCount;
		}

		const totalHeight = this.#height.body - this.#height.thead - this.#height.tfoot - this.#getPinHeight();
		//console.log("=======totalHeight: ", this.#height, this.#getPinHeight());

		var rowCount = 0;
		var h = 0;
		while (h < totalHeight) {
			h += this.getRowHeight(this.#rawIndex + rowCount++);
		}

        //console.log("=======: ", this.#rawIndex, rowCount, this.#owner.data.count());
		if (this.#rawIndex + rowCount > this.#owner.data.count()) {

			rowCount = 0;
			h = 0;
			for (var i = this.#owner.data.count() - 1; i >= 0 && h < totalHeight; i--) {
				h += this.getRowHeight(i);
				rowCount++;
			}
			
			if  (h > totalHeight) rowCount --;
			
			this.#rawIndex = this.#owner.data.count() - rowCount;

			this.#owner.dataManager.viewRecords.rawIndex = this.#rawIndex;
		}

		//console.log("=======rowCount: ", rowCount);

		return rowCount;
	};
	
	#createTR = () => {

		// 1. 스크린에 보여질 TR 갯수 계산
		var rowCount = this.#getRowCount();

		// 0. TR 생성여부 판단
		//if (!this.#owner.body.querySelector(".ng-container-body tbody.bindable tr:not(.nodata)") || this.isLastPage) {
			// 2. TR 생성
			var startRow = $(".ng-container-body tbody.bindable tr", this.#owner.body).not('tr.nodata').length / (this.#owner.template.length || 1);

			
			const leftTmpl	= this.#owner.template.clone();
			const rightTmpl	= leftTmpl.clone();//this.#owner.template.clone();
			const bodyTmpl	= leftTmpl.clone();//this.#owner.template.clone();
			
			leftTmpl	.find("th,td").not("[fixed=left]").remove();
			rightTmpl	.find("th,td").not("[fixed=right]").remove();
			bodyTmpl	.find("th[fixed=left],td[fixed=left],th[fixed=right],td[fixed=right]").remove();
			
			const leftNoData	= $("tr.nodata", this.#owner.body.querySelector(".ng-container-left"));
			const rightNoData	= $("tr.nodata", this.#owner.body.querySelector(".ng-container-right"));
			const bodyNoData	= $("tr.nodata", this.#owner.body.querySelector(".ng-container-body"));
			
			for (var i = startRow; i < rowCount; i++) {

				
				leftTmpl	.each((i,tr) => { leftNoData	.before(tr.outerHTML); });
				rightTmpl	.each((i,tr) => { rightNoData	.before(tr.outerHTML); });
				bodyTmpl	.each((i,tr) => { bodyNoData	.before(tr.outerHTML); });
			}
		//}
		
			
		
		// 3. 불필요 TR 제거
		/**
		rowCount = Math.min(rowCount, this.#owner.data.count());// + ($(".ng-container-body tbody.fixed tr", this.#owner.body).length / this.#owner.template.length);
		$(".ng-container tbody.bindable tr", this.#owner.body).not(".nodata").each((i,tr) => {
			if (parseInt(tr.sectionRowIndex / this.#owner.template.length) >= rowCount) {
				$(tr).remove();
			}
		}); */
		
		return;
		
		// 4. row resize
		var trsBody	= $(".ng-container-body tbody.bindable tr:not(.nodata)", this.#owner.body);
		var trsLeft	= $(".ng-container-left tbody.bindable tr:not(.nodata)", this.#owner.body);
		var trsRight= $(".ng-container-right tbody.bindable tr:not(.nodata)", this.#owner.body);
		
		if (trsBody.length > 0) {
			var startRow = parseInt(this.#rawIndex * this.#owner.template.length);
			
			trsBody.each((i, tr) => {
				
				var h = this.#owner.matrix.getHeight(startRow + i);// || 32;

				$("canvas.chart", tr).css({ "height" : h-4 });
				$("canvas.chart", trsLeft.eq(i)).css({ "height" : h-4 });
				$("canvas.chart", trsRight.eq(i)).css({ "height" : h-4 });
				
				//$(tr).height(h);
				$(tr).css({ "height" : h }).height(h);
				trsLeft.eq(i).css({ "height" : h }).height(h);
				trsRight.eq(i).css({ "height" : h }).height(h);
			});
		}
	};
	
	#removeGarbageTR = () => {
		
		var rowCount = Math.min(this.#getRowCount(), this.#owner.data.count());// + this.pin.count();

		
		$(".ng-container tbody.bindable tr:not(.nodata)", this.#owner.body).each((i,tr) => {
			if (parseInt(tr.sectionRowIndex / this.#owner.template.length) >= rowCount) {
				$(tr).remove();
			}
		});

		this.#owner.body.querySelectorAll(".ng-container tbody.bindable tr:not(.nodata)").forEach(tr => {
			const row = this.#rawIndex + parseInt(tr.sectionRowIndex / this.#owner.template.length);
			if (row >= this.#owner.data.count()) {
				$(tr).remove();
			}
		});
	};
	
	#resetTR3 = () => {

		// 1. TR 생성
		this.#createTR();

		this.#removeGarbageTR();

		// 5. nodata resize

		var h = this.#height.body - this.#height.thead - this.#height.tfoot - this.#getTrHeight();
		if (this.#owner.getAttribute("display-row-count")) {
			if (this.#owner.data.count() >= Number(this.#owner.getAttribute("display-row-count") || 0)) {
				h = 0;
			}
		}
		
		$(".ng-container tbody.bindable tr.nodata", this.#owner.body).height(h);


		//console.log("#resetTR3", this.#owner, h);
		
		/**
		this.#owner.body.querySelector(".ng-container-body .ng-table").style.top = 0;
		this.#owner.body.querySelector(".ng-container-left .ng-table").style.top = 0;
		this.#owner.body.querySelector(".ng-container-right .ng-table").style.top = 0;
		*/
		
		//$('.ng-container .ng-table', this.#owner.body).offset({top:$('.ng-container .ng-table', this.#owner.body).offset().top});
		//$('.ng-container .ng-table', this.#owner.body).offset({top:$('.ng-container .ng-table', this.#owner.body).offset().top});
		//this.isLastPage = h > 0 ? true : false;

		
		if (this.#owner.closest("dialog") && ninegrid.j.querySelectorAll(this.#owner).hasClass("simple")) {
			$("tr.nodata", this.#owner.body).height(0);
			
			var h = 47;//this.#getTrHeight();
			$('.ng-container-body tbody.bindable tr', this.#owner.body).not('.nodata').each((i,tr) => {
				h += $(tr).height();
			});

			$(this.#owner.closest("dialog")).height(h);
		}
	};

	#resetTR3V2 = () => {
		
		// 1. TR 생성
		//this.#owner.isLastPage = rows[rows.length-1] == this.#owner.data.count() - 1 ? true : false;//this.#isLastPage();
		
		//if (this.#owner.isLastPage) {
		//if (this.#isLastPage) {

		//if (this.#owner.isLastPage) {
			this.#createTR();
		//}
		/**
		if ($(".ng-container-body tbody.bindable tr.nodata", this.#owner.body).height() > 0) {
			this.#createTR();
		} */

		this.#removeGarbageTR();

		
		// 5. nodata resize
		/**
		if (this.#owner.isFirstPage || this.#owner.isLastPage) {
			var h = this.#owner.body.querySelector("ng-vscrollbar").bodyHeight - $(".ng-container-body .ng-table", this.#owner.body).height() + $('.ng-container-body .ng-table tr.nodata', this.#owner.body).height();
			$(".ng-container tbody.bindable tr.nodata", this.#owner.body).height(h);
		}*/
		//$(".ng-container tbody.bindable tr.nodata", this.#owner.body).height(700);
		
		if (this.#owner.isLastPage) {
			//var h = this.#height.body - this.#height.thead - this.#height.tfoot - this.#getTrHeight();
			//$(".ng-container tbody.bindable tr.nodata", this.#owner.body).height(h);
		}

		
		//this.isLastPage = h > 0 ? true : false;

		
		//this.nodata = h > 0 ? true : false;
		
		// 6. 마지막 TR tabindex
	};
	
	#refreshData = () => {
		
		for (const v of this.#timers) {
			clearTimeout(v);
		}
		this.#timers = [];

		this.#timers.push(setTimeout(() => {
			
			this.#ing = false;
			
			// 4. row resize
			var trsBody	= $(".ng-container-body tbody.bindable tr", this.#owner.body).not(".nodata");
			var trsLeft	= $(".ng-container-left tbody.bindable tr", this.#owner.body).not(".nodata");
			var trsRight= $(".ng-container-right tbody.bindable tr", this.#owner.body).not(".nodata");
			
			if (trsBody.length > 0) {
				var startRow = parseInt(trsBody[0].dataset.row * this.#owner.template.length);
				
				trsBody.each((i, tr) => {
					var h = this.#owner.matrix.getHeight(startRow + i);// || 32;

					$("canvas.chart", tr).css({ "height" : h-4 });
					$("canvas.chart", trsLeft.eq(i)).css({ "height" : h-4 });
					$("canvas.chart", trsRight.eq(i)).css({ "height" : h-4 });

					$(tr).css({ "height" : h }).height(h);
					trsLeft.eq(i).css({ "height" : h }).height(h);
					trsRight.eq(i).css({ "height" : h }).height(h);
				});
			}
			
			this.#owner.cell.refresh();
			
			//row resize
			$('ng-row-indicator', this.#owner.body).each((i,el) => {
				el.refresh();
			});
			
			//5. nodata resize
			var h = this.#height.body - this.#height.thead - this.#height.tfoot - this.#getTrHeight();

			//console.log(this.#owner, this.#owner.data.count(), this.#owner.getAttribute("display-row-count"))
			if (this.#owner.getAttribute("display-row-count")) {
				if (this.#owner.data.count() >= Number(this.#owner.getAttribute("display-row-count") || 0)) {
					h = 0;
				}
			}

			$(".ng-container tbody.bindable tr.nodata", this.#owner.body).height(h);

			
			//console.log("#refreshData", this.#owner.viewRecords);
			//this.isLastPage = h > 0 ? true : false;

			
			this.#owner.refreshBindRows();

			this.#owner.refreshData();
			
			this.#owner.paging.totalCount = this.#owner.data.countNF();
			
			this.#owner.body.querySelector("ng-vscrollbar").refresh();

			ninegrid.j.querySelectorAll(".ng-table tbody tr", this.#owner.body).removeClass("hover");
			ninegrid.j.querySelectorAll(this.#owner).removeClass("loading");
			ninegrid.j.querySelectorAll("ng-filter-panel").removeClass("loading");
			
			/**
			this.#owner.body.querySelector(".ng-container-left").style.position = "sticky";
			this.#owner.body.querySelector(".ng-container-right").style.position = "sticky";
			this.#owner.body.querySelector(".ng-container-body").style.position = "sticky";
			this.#owner.body.querySelector(".ng-container-left").style.top = "0px";
			this.#owner.body.querySelector(".ng-container-right").style.top = "0px";
			this.#owner.body.querySelector(".ng-container-body").style.top = "0px";
			
			setTimeout(() => {
				this.#owner.body.querySelector(".ng-container-left").style.position = "relative";
				this.#owner.body.querySelector(".ng-container-right").style.position = "relative";
				this.#owner.body.querySelector(".ng-container-body").style.position = "relative";
				this.#owner.body.querySelector(".ng-container-left").style.top = "0px";
				this.#owner.body.querySelector(".ng-container-right").style.top = "0px";
				this.#owner.body.querySelector(".ng-container-body").style.top = "0px";
			}, 1000); */

		}, 300));
		
		//if (!this.timers) this.timers = [];
		this.#timers.push(setTimeout(() => {
			this.#owner.refreshDataV2();
		}));
	}
	
	#r = () => {

		var rows = [];
		this.#owner.body.querySelectorAll(".ng-container-body tbody.bindable tr:not(.nodata)").forEach(tr => {
			rows.push(this.#rawIndex + parseInt(tr.sectionRowIndex / this.#owner.template.length));
		});
		
		rows = [...new Set(rows)];
		
		this.#owner.body.querySelectorAll(".ng-container tbody.bindable tr:not(.nodata)").forEach(tr => {
			const index = parseInt(tr.sectionRowIndex / this.#owner.template.length);

			tr.dataset.row			= rows[index];
			tr.dataset.matrixRow	= parseInt(rows[index] * this.#owner.template.length) + parseInt(tr.sectionRowIndex % this.#owner.template.length);
			
			for (const cell of tr.cells) {
				cell.dataset.row		= tr.dataset.row;
				cell.dataset.matrixRow	= tr.dataset.matrixRow;
			}
		});
		

		rows.forEach(row => {
			const data = this.#owner.data.get(row);

			this.#owner.body.querySelectorAll(`.ng-container tbody.bindable tr[data-row="${row}"]`).forEach(tr => {
				tr.data	= data;
			});
		});
		
		this.#rawIndex = parseInt(this.#owner.body.querySelector(".ng-container-body tbody.bindable tr:first-of-type").getAttribute("data-row"));
		
		this.#owner.dataManager.viewRecords.rawIndex = this.#rawIndex;


		this.#refreshData();
		
		//this.#owner.isFirstPage = this.#rawIndex == this.#owner.cell.firstRow() ? true : false;
		this.#owner.isFirstPage = this.#rawIndex == 0 ? true : false;
		//this.#owner.isLastPage = this.isLastPage;
		

		this.#owner.isLastPage = rows[rows.length-1] == this.#owner.data.count() - 1 ? true : false;//this.#isLastPage();
		//this.#owner.lastHidden = (parseInt($(".ng-container-body", this.#owner.body).height() - ($(".ng-container-body tfoot", this.#owner.body).height() || 0) + 2) >= t + h) ? false : true;

		//this.#owner.body.querySelector("ng-vscrollbar").refresh();
	};
	
	getVisibleFirstRow = () => {
		var tr = this.#owner.body.querySelector(".ng-container-body tbody.bindable tr:first-child");
		return parseInt(tr.dataset.row);
	};
	
	getVisibleLastRow = () => {
		var trs = this.#owner.body.querySelectorAll(".ng-container-body tbody.bindable tr:not(.nodata)");
		return (trs.length > 0) ? parseInt(trs[trs.length - 1].dataset.row) : -1;
	};
	
	getRowHeight = (rowIndex) => {
		let h = 0;
		
		for (var i = 0; i < this.#owner.template.length; i++) {
			h += this.#owner.matrix.getHeight(parseInt(rowIndex * this.#owner.template.length + i));
		}
		
		return h;
	};
	
	getTranslateY = () => {
		const tbody = this.#owner.body.querySelector(".ng-container-body tbody.bindable");
		return (!tbody || !tbody.style || !tbody.style.transform) ? 0 : parseFloat(tbody.style.transform.replace("translateY(", "").replace(")", ""));
	};
	
	getTotalSpace = () => {
		
		return $(this.#owner.body.querySelector(".ng-container-body")).height()
					- ($(this.#owner.body.querySelector(".ng-container-body thead")).height() || 0)
					- ($(this.#owner.body.querySelector(".ng-container-body tfoot")).height() || 0)
					- ($(this.#owner.body.querySelector(".ng-container-body tbody.fixed")).height() || 0);
					//- this.getTranslateY();
	};
	
	fitPage = () => {
		const lastRow		= this.getVisibleLastRow();
		const totalSpace	= this.getTotalSpace();
		
		/**
		 * 마지막 페이지 정리
		 */
		if (lastRow == this.#owner.data.count() - 1) {
			var h = 0;
			for (var i = lastRow; i >= 0; i--) {
				h += this.getRowHeight(i);
				
				if (h > totalSpace) {
					this.#owner.scrollTo(i + 1);
					break;
				}
			}
		}
	}
	/**
	#isLastPage = () => {
		const arr = this.#owner.body.querySelectorAll(".ng-container-body tbody.bindable tr:not(.nodata)");
		if (arr.length <= 0) return null;

		return arr[arr.length - 1].dataset.row == this.#owner.data.count() - 1 ? true : false;
	}*/
	
	
	/**
	 * grid.selectCell(row, colnm, subrow) => scrollTo
	 * grid.selectCol(fromColNm, toColNm)
	 * grid.selectRow(row) => scrollTo
	 * grid.selectArea(row1, col1, row2, col2) => scrollTo
	 * 
	 * grid.clearSelect()
	 * 
	 * grid.selection.currentCell;
	 * grid.selection.currentRow;
	 * grid.selection.currentSubRow;
	 * grid.selection.currentCol;
	 * grid.selection.firstRow
	 * grid.selection.firstCol
	 * grid.selection.lastRow
	 * grid.selection.lastCol
	 */
	
	selectArea = (oRow1, oCol1, oRow2, oCol2) => {
			
		const row1		= this.#getRowIndex(oRow1);
		const row2		= this.#getRowIndex(oRow2);
		const col1		= this.#getColIndex(oCol1);
		const col2		= this.#getColIndex(oCol2);
		const matrixRow1= parseInt(row1 * this.#owner.template.length);
		const matrixRow2= parseInt(row2 * this.#owner.template.length) + this.#owner.template.length - 1;
		
		this.#owner.row.at = row1;
		
		(row1 >= 0 && row2 >= 0) ? this.#owner.selection.selectArea(matrixRow1, col1, matrixRow2, col2) : this.clearSelection();
	};
	
	selectRow = (oRow1, oRow2) => {
			
		const row1		= this.#getRowIndex(oRow1);
		const row2		= ninegrid.isNull(oRow2) ? row1 : this.#getRowIndex(oRow2);
		const matrixRow1= parseInt(row1 * this.#owner.template.length);
		const matrixRow2= parseInt(row2 * this.#owner.template.length) + this.#owner.template.length - 1;
		
		this.#owner.row.at = row1;
		
		(row1 >= 0 && row2 >= 0) ? this.#owner.selection.selectArea(matrixRow1, this.#owner.firstCol, matrixRow2, this.#owner.lastCol) : this.clearSelection();
	};
	
	selectCol = (oCol1, oCol2) => {
		const col1		= this.#getColIndex(oCol1);
		const col2		= ninegrid.isNull(oCol2) ? col1 : this.#getColIndex(oCol2);
		const matrixRow1= 0;
		const matrixRow2= parseInt(this.#owner.data.count() * this.#owner.template.length - 1);

		(col1 >= 0 && col2 >= 0) ? this.#owner.selection.selectArea(matrixRow1, col1, matrixRow2, col2) : this.clearSelection();
	};
	
	selectCell = (oRow, oCol, subrow) => {
		
		const row		= this.#getRowIndex(oRow);
		const col		= this.#getColIndex(oCol);
		const matrixRow	= parseInt(row * this.#owner.template.length) + ninegrid.nvl(subrow, 0);
		
		this.#owner.row.at = row;
		
		(row >= 0) ? this.#owner.selection.selectArea(matrixRow, col, matrixRow, col) : this.clearSelection();
	};
	
	#getRowIndex = (oRow) => {
		if (typeof oRow === "number") {
			return oRow;
		}
		else if (typeof oRow === "function") {
			return this.#owner.data.findIndex(oRow);
		}
		else {
			throw `invalid ${oRow}`;
		}
	};
	
	#getColIndex = (oCol) => {
		if (typeof oCol === "number") {
			return oCol;
		}
		else if (typeof oCol === "string" && this.#owner.fields.includes(oCol)) {
			return  parseInt($(`[data-bind="${oCol}"]`, this.#owner.template)[0].dataset.col);
		}
		else {
			throw `invalid ${oCol}`;
		}
	};
	
	
	
	moveTo = (at) => {
		this.#owner.scrollTo(at);
	}
}
